export default __webpack_public_path__ + "b257a18c016f37ee45430f59757a0db9.ttf";